import { useEffect } from 'react'
import { jsPDF } from 'jspdf'

// Map image export (S8). Listens for a `map-export` window event
// { format: 'png' | 'pdf' } (and the legacy `export-map-png`). Snapshots the map
// canvas once it's idle — at the canvas's device-pixel resolution, so retina
// screens already yield a high-resolution image — then downloads a PNG or wraps
// it in a fitted A4-landscape PDF.
export function useMapExport(map, showToast) {
  useEffect(() => {
    const snapshot = (format) => {
      if (!map.current) return
      try {
        map.current.once('idle', () => {
          const canvas = map.current.getCanvas()
          const dataURL = canvas.toDataURL('image/png')
          const stamp = new Date().toISOString().split('T')[0]
          if (format === 'pdf') {
            const w = canvas.width
            const h = canvas.height
            const pdf = new jsPDF({ orientation: w >= h ? 'landscape' : 'portrait', unit: 'pt', format: 'a4' })
            const pageW = pdf.internal.pageSize.getWidth()
            const pageH = pdf.internal.pageSize.getHeight()
            const scale = Math.min(pageW / w, pageH / h)
            const imgW = w * scale
            const imgH = h * scale
            pdf.addImage(dataURL, 'PNG', (pageW - imgW) / 2, (pageH - imgH) / 2, imgW, imgH)
            pdf.save(`map-${stamp}.pdf`)
          } else {
            const link = document.createElement('a')
            link.href = dataURL
            link.download = `map-plan-${stamp}.png`
            link.click()
          }
        })
      } catch (error) {
        console.error('Error exporting map:', error)
        if (showToast) showToast('Erreur lors de l\'export', 'error')
      }
    }

    const onPng = () => snapshot('png')
    const onExport = (e) => snapshot(e.detail?.format || 'png')
    window.addEventListener('export-map-png', onPng)
    window.addEventListener('map-export', onExport)
    return () => {
      window.removeEventListener('export-map-png', onPng)
      window.removeEventListener('map-export', onExport)
    }
  }, [map, showToast])
}
